import Vue from 'vue'
import menu from './menu'
// var menu = []

import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    ...generateRoutesFromMenu(menu),
    {
      path: '*',
      redirect: { name: 'unit' }
    }
  ]
})

let previousRoute = null

router.beforeEach((to, from, next) => {
  // Store previous route only if it's valid
  if (from.name) {
    previousRoute = {
      name: from.name,
      query: from.query
    }
  }
  next()
})


function generateRoutesFromMenu (menu = [], routes = []) {
  for (let i = 0, l = menu.length; i < l; i++) {
    let item = menu[i]
    if (item.path) {
      routes.push(item)
    }
    generateRoutesFromMenu(item.children, routes)
  }
  return routes
}

export { router, previousRoute }
export default router



// WEBPACK FOOTER //
// ./src/router/index.js